// Import
import { IconButton } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  InputCst,
  SelectCst,
  AutocompleteCst,
  MultiSelectCst,
  RadioCst,
  DataPickerCst,
  SingleCheckboxCst,
  InputAssociationChipsCst,
  MultiTextCst,
  EuroTextCst,
} from "@components/InputCst";
import { ColumnInterface } from "@components/Table/types";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { defaultValidation } from "@utils/utilsValidators";
import DownloaderUploaderCst from "@components/DownloaderUploaderCst";
import InputChipsCst from "@components/InputCst/InpuctChipsCst";
import TimePickerCst from "@components/InputCst/TimePickerCst";
import { TextEditorCst } from "@components/TextEditorCst";
import { Association } from "src/interfaces/Common";
import { Delete, Save } from "@mui/icons-material";
import { isTrueValue } from "@utils/utilsValidators";
import ModalConfirmsCst from "@components/ModalConfirmsCst";

// Interface

interface MacroCategoriesCstInterface {
  row?: any;
  editIndex?: number;
  columns: ColumnInterface[];
  additionalColumns?: ColumnInterface[];
  actionsForForms?: ColumnInterface[];
  onSubmit: (detailForm: any) => void;
  onReset?: () => void;
  onResetEdit?: () => void;
  formActionType?: string[];
  inputsException?: (col: any, detailForm: any) => any;
  backButton?: () => any;
  getValues?: (accessorKey: string) => any;
  handleDelete?: (accessorKey: string, element: any) => void;
  handleAssociation?: (accessorKey: string, value: any) => void;
  setOpenAssociation?: (
    accessorKey: string,
    open: boolean,
    detailForm: any,
  ) => void;
  association?: boolean | Association;
  disabledConfig?: { view: string; accessoryKey: string };
  readOnly?: boolean;
  deleteDisabled?: boolean;
  options?: any;
  setDetailForm?: any;
  detailForm?: any;
  detailsCount?: number;
  details?: any;
  mainForm?: any;
  isNew?: boolean;
  dataProject?: any;
  setAccountsAssociation?: any;
  accountsAssociation?: any;
  setMacroAssociation?: any;
  macroAssociation?: any;
  flagDetail?: any;
  setFlagDetail?: any;
}

// eslint-disable-next-line no-empty-pattern
const MacroCategoriesFormCst: React.FC<MacroCategoriesCstInterface> = ({
  details,
  row,
  editIndex,
  columns,
  actionsForForms = [],
  inputsException,
  onSubmit,
  onReset,
  onResetEdit,
  backButton,
  getValues,
  handleDelete,
  handleAssociation,
  setOpenAssociation,
  association,
  readOnly,
  setDetailForm,
  detailForm,
  dataProject,
  setAccountsAssociation,
  accountsAssociation,
  setMacroAssociation,
  macroAssociation,
  flagDetail,
  setFlagDetail,
  mainForm,
  isNew,
}) => {
  const { t } = useTranslation(["form"]);
  const [errorDetailForm, setErrorDetailForm] = React.useState<any>({});
  const [fileUploaded, setFileUploaded] = React.useState<any>(null);
  const [showModalWarning, setShowModalWarning] = useState(false);
  const [showModalMacro, setShowModalMacro] = useState(false);

  const getInitialData = () => {
    let initialState: Record<string, any> = {};
    columns?.forEach(({ accessorKey }) => {
      switch (accessorKey) {
        case "account":
          if (
            row.account != null &&
            !Array.isArray(row.account) &&
            Object.keys(row.account).length > 0
          ) {
            setAccountsAssociation && setAccountsAssociation([row.account]);
          } else if (
            row.account != null &&
            Array.isArray(row.account) &&
            row.account.length > 0
          ) {
            setAccountsAssociation && setAccountsAssociation(row.account);
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "macro_category":
          if (
            row.macro_category != null &&
            !Array.isArray(row.macro_category) &&
            Object.keys(row.macro_category).length > 0
          ) {
            setMacroAssociation && setMacroAssociation([row.macro_category]);
          } else if (
            row.macro_category != null &&
            Array.isArray(row.macro_category) &&
            row.macro_category.length > 0
          ) {
            setMacroAssociation && setMacroAssociation(row.macro_category);
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "internal":
          if (row.macro_category?.internal != null) {
            row.internal = row.macro_category.internal;
          }
          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;

        default:
          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
      }
    });

    return initialState;
  };

  useEffect(() => {
    if (
      flagDetail &&
      row &&
      Object.keys(row).length > 0 &&
      columns?.length > 0
    ) {
      setFlagDetail(false);
      const initialState = getInitialData();
      setDetailForm(initialState);

      // Disable all columns if readOnly=true prop is passed
      if (readOnly) {
        columns?.forEach((column) => (column.disabled = true));
      }
    }

    if (isNew) {
      const totalAllocatedBudget = details.reduce((total: any, item: any) => {
        const allocatedBudget = Number(item.allocated_budget) || 0;
        return total + allocatedBudget;
      }, 0);

      let diffBudget = parseFloat(
        (Number(mainForm?.allocated_budget) - totalAllocatedBudget).toFixed(2),
      );

      setDetailForm({
        ...detailForm,
        ...{ allocated_budget: diffBudget },
      });
    }
  }, [flagDetail]);

  const onConfirm = () => {
    const { canBeSubmit, showError } = defaultValidation(columns, detailForm);
    setErrorDetailForm(showError);

    //Clona la lista dei dettagli
    const updatedBudgetDetails = [...details];
    const updatedMacroDetails = [...details];

    //Aggiorna il dettaglio corrente se in modifica
    if (editIndex !== undefined && Object.keys(row).length > 0) {
      updatedBudgetDetails[editIndex - 1] = detailForm;
    } else {
      updatedBudgetDetails.push(detailForm);
    }

    //Somma i budget allocati
    const totalAllocatedBudget = updatedBudgetDetails.reduce((total, item) => {
      const allocatedBudget = Number(item.allocated_budget) || 0;
      return total + allocatedBudget;
    }, 0);

    // Verifica se il budget totale supera quello del progetto
    if (totalAllocatedBudget > mainForm.allocated_budget) {
      setShowModalWarning(true);
      return;
    }

    //Rimuovi l’item in modifica dalla lista per il check sulle macro category duplicate
    if (editIndex !== undefined && Object.keys(row).length > 0) {
      updatedMacroDetails.splice(editIndex - 1, 1);
    }

    //Estrai tutti gli ID delle macro_category già presenti
    const existingMacroCategoryIds = updatedMacroDetails.flatMap((item) => {
      const { macro_category } = item;

      if (Array.isArray(macro_category)) {
        return macro_category.map((cat: any) => Number(cat.id));
      }

      if (macro_category && typeof macro_category === "object") {
        return [Number(macro_category.id)];
      }

      return [];
    });

    //Ottieni l’ID della macro_category attualmente selezionata
    const currentMacroCategoryId = Array.isArray(detailForm?.macro_category)
      ? detailForm?.macro_category[0]?.id
      : detailForm?.macro_category?.id;

    const isDuplicateMacroCategory =
      currentMacroCategoryId !== undefined &&
      currentMacroCategoryId !== null &&
      existingMacroCategoryIds.includes(Number(currentMacroCategoryId));

    //Mostra errore se la macro category è già presente
    if (isDuplicateMacroCategory) {
      setShowModalMacro(true);
      return;
    }

    //Invia i dati se tutto è valido
    if (canBeSubmit) {
      onSubmit(detailForm);
    }
  };

  const getErrMsg = (accessorKey: string): string => {
    return errorDetailForm[accessorKey]?.msg || errorDetailForm[accessorKey];
  };

  const minLength = (accessorKey: string): number => {
    return errorDetailForm[accessorKey]?.value;
  };

  const maxLength = (accessorKey: string): number => {
    return errorDetailForm[accessorKey]?.value;
  };

  const getInputsList = (col: any, detailForm: any) => {
    if (inputsException) {
      col = inputsException(col, detailForm);
    }

    if (col.accessorKey === "account") {
      if (
        detailForm.internal != null &&
        !isTrueValue(detailForm.internal.toString())
      ) {
        col.disabled = false;
        col.required = true;
      } else {
        col.disabled = true;
        col.required = false;
      }
    }

    if (col.accessorKey === "macro_category") {
      if (
        (accountsAssociation != null && accountsAssociation.length > 0) ||
        (detailForm.internal != null &&
          isTrueValue(detailForm.internal.toString()))
      ) {
        col.disabled = false;
      } else {
        col.disabled = true;
      }
    }

    if (col.accessorKey === "allocated_budget") {
      let tempDetails = [...details];

      if (editIndex !== undefined && Object.keys(row).length > 0) {
        tempDetails = tempDetails.filter((_, index) => index !== editIndex - 1);
      }

      const totalAllocatedBudget = tempDetails.reduce(
        (total: number, item: { allocated_budget: number }) => {
          const allocatedBudget = Number(item.allocated_budget) || 0;
          return total + allocatedBudget;
        },
        0,
      );

      if (col.rules.maxValue.value !== undefined) {
        let diffBudget = parseFloat(
          (Number(mainForm?.allocated_budget) - totalAllocatedBudget).toFixed(
            2,
          ),
        );
        col.rules.minValue.value = 1;
        col.rules.maxValue.value = diffBudget;
        col.tooltip = `${t("category-form.allocated-budget-diff")}: ${diffBudget}`;
      }
    }

    switch (col.type) {
      case "association": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={3}>
            <InputAssociationChipsCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={getValues && getValues(col.accessorKey)}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              noAssociationButton={col.disableAssociationButton}
              disabled={col.disabled}
              textTooltip={col.tooltip}
              required={col.required}
              onDelete={(e: any) => {
                handleDelete && handleDelete(col.accessorKey, e);
                setDetailForm({
                  ...detailForm,
                });
              }}
              onRedirect={() => {
                setOpenAssociation &&
                  setOpenAssociation(col.accessorKey, true, detailForm);
              }}
              labelKey={col.labelKey}
            />
          </Grid>
        );
      }
      case "singleCheckbox": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <SingleCheckboxCst
              key={col.accessorKey}
              id={col.accessorKey}
              value={detailForm[col.accessorKey]}
              label={col.header}
              onChange={(e: any) => {
                setDetailForm({
                  ...detailForm,
                  ...{ [col.accessorKey]: e.target.checked },
                });
              }}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
            />
          </Grid>
        );
      }
      case "text": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={3}>
            <InputCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setDetailForm({
                  ...detailForm,
                  ...{ [col.accessorKey]: e.target.value },
                });
              }}
              maxValue={col?.rules?.max?.value}
              multiline={col.multiline}
              rows={col.rows}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
              textTooltip={col.tooltip}
              type={col.inpuType || "text"}
            />
          </Grid>
        );
      }
      case "chips": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <InputChipsCst
              label={col.header}
              id={col.accessorKey}
              value={detailForm[col.accessorKey]}
              required={col.required}
              maxLength={col?.rules?.max?.value}
              disabled={col.disabled}
              textTooltip={col.textTooltip}
              validationType={col.validationType}
              error={errorDetailForm[col.accessorKey] ? true : false}
              onAdd={(list: any[]) => {
                setDetailForm({
                  ...detailForm,
                  ...{ [col.accessorKey]: list },
                });
              }}
              deleteDisabled={col.deleteDisabled}
              undeletableValues={col.undeletableValues}
            />
          </Grid>
        );
      }
      case "select": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={3}>
            <SelectCst
              key={col.accessorKey}
              id={col.accessorKey}
              optionsKey={col.optionsKey}
              label={col.header}
              optionsToDisable={col.optionsToDisable}
              value={detailForm[col.accessorKey]}
              service={col.service}
              queryParams={col.queryParams || ""}
              required={col.required}
              onChange={(e: any) => {
                if (col.callBack) {
                  setDetailForm(col.callBack(e, row));
                } else {
                  setMacroAssociation([]);
                  setAccountsAssociation([]);
                  setDetailForm({
                    ...detailForm,
                    ...{ [col.accessorKey]: e },
                  });
                }
              }}
              options={col?.options}
              textTooltip={col.tooltip}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "select-checkbox": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <MultiSelectCst
              id={col.accessorKey}
              label={col.header}
              optionsKey={col.optionsKey}
              value={detailForm[col.accessorKey]}
              optionsToDisable={col.optionsToDisable}
              disabled={col.disabled}
              onChange={(e: any) => {
                let newValue = JSON.parse(JSON.stringify(e));
                let newsessionForm = JSON.parse(JSON.stringify(detailForm));
                setDetailForm({
                  ...newsessionForm,
                  ...{ [col.accessorKey]: newValue },
                });
              }}
              options={col.options}
              required={col.required}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
            />
          </Grid>
        );
      }
      case "autocomplete": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <AutocompleteCst
              key={col.accessorKey}
              id={col.accessorKey}
              optionsKey={col.optionsKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setDetailForm({ ...detailForm, ...{ [col.accessorKey]: e } });
              }}
              options={col?.options}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "multiCheckbox": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <MultiSelectCst
              key={col.accessorKey}
              id={col.accessorKey}
              optionsKey={col.optionsKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              textTooltip={col.tooltip}
              required={col.required}
              service={col.service}
              onChange={(e: any) => {
                setDetailForm({ ...detailForm, ...{ [col.accessorKey]: e } });
              }}
              options={col?.options}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "radio": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <RadioCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              onChange={(e: any) => {
                setDetailForm({ ...detailForm, ...{ [col.accessorKey]: e } });
              }}
              options={col.options}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "dateTime": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <DataPickerCst
              id={col.accessorKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              required={col.required}
              minDate={col.minDate}
              onChange={(e: any) => {
                setDetailForm({ ...detailForm, ...{ [col.accessorKey]: e } });
              }}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "dateTimeYear": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <DataPickerCst
              views={["year"]}
              id={col.accessorKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setDetailForm({ ...detailForm, ...{ [col.accessorKey]: e } });
              }}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "time": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <TimePickerCst
              id={col.accessorKey}
              value={detailForm[col.accessorKey]}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`) || "Error"
              }
              required={col.required}
              label={col.header}
              disabled={col.disabled}
              minDate={col.minDate || ""}
              onChange={(e: any) => {
                setDetailForm({ ...detailForm, ...{ [col.accessorKey]: e } });
              }}
            />
          </Grid>
        );
      }
      case "multi-text": {
        return (
          <MultiTextCst
            key={col.accessorKey}
            label={col.header}
            fields={col.fields}
            value={detailForm[col.accessorKey]}
            disabled={col.disabled}
            onChange={(e: any) => {
              setDetailForm({
                ...detailForm,
                ...{ [col.accessorKey]: e },
              });
            }}
          />
        );
      }
      case "editor": {
        return (
          <TextEditorCst
            options={col.editorOptions}
            value={detailForm[col.accessorKey]}
            onChange={(e: any) => {
              setDetailForm((prev: any) => {
                return {
                  ...prev,
                  [col.accessorKey]: e,
                };
              });
            }}
          />
        );
      }
      case "upload": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={6}>
            <DownloaderUploaderCst
              name={col.header}
              accept={col?.accept}
              url={col.service}
              type={col.upload_type}
              onChange={(e: any) => {
                setDetailForm({
                  ...detailForm,
                  [col.accessorKey]: {
                    e,
                  },
                });
                setFileUploaded({
                  ...fileUploaded,
                  [col.accessorKey]: {
                    file: e,
                  },
                });
              }}
              fileName={!!row?.originalFileName && row.originalFileName}
              downloadDisabled={!!col.downloadDisabled}
              onDownload={col.downloadCallback && col.downloadCallback}
              onTemplateDownload={col.templateCallback && col.templateCallback}
              onDelete={
                col.deleteCallback &&
                (() => {
                  setFileUploaded(null);
                  return col.deleteCallback && col.deleteCallback();
                })
              }
              disabled={col.disabled}
              required={col?.required}
              showError={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
            />
          </Grid>
        );
      }
      case "euro-text": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={3}>
            <EuroTextCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={detailForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setDetailForm({
                  ...detailForm,
                  ...{ [col.accessorKey]: e.target.value },
                });
              }}
              maxValue={col?.rules?.max?.value}
              multiline={col.multiline}
              rows={col.rows}
              error={errorDetailForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
              textTooltip={col.tooltip}
              type={col.inpuType || "text"}
            />
          </Grid>
        );
      }
      default:
        return <></>;
    }
  };

  const getInputField = useMemo(() => {
    return columns?.map((col: any) => {
      return getInputsList(col, detailForm);
    });
  }, [detailForm]);

  return (
    <>
      <Grid container sx={{ mt: "2rem" }}>
        <Grid item xs={12} sm={1}>
          <IconButton
            color={"primary"}
            aria-label="Reset Cateogry"
            onClick={!!Object.keys(row).length ? onResetEdit : onReset}
          >
            <Delete />
          </IconButton>
          <IconButton aria-label="save Category" onClick={onConfirm} edge="end">
            <Save />
          </IconButton>
        </Grid>
        <Grid item xs={12} sm={11}>
          <Grid container spacing={2}>
            {getInputField}
          </Grid>
        </Grid>
      </Grid>
      <ModalConfirmsCst
        open={showModalWarning}
        title={t("category-form.allocated-budget-warning.title")}
        description={t("category-form.allocated-budget-warning.description")}
        routeToSamePage={true}
        removeButtons={true}
        onActionConfirmed={() => {
          setShowModalWarning(false);
        }}
        onCallBackClosed={() => {
          setShowModalWarning(false);
        }}
      />
      <ModalConfirmsCst
        open={showModalMacro}
        title={t("category-form.macro-budget-warning.title")}
        description={t("category-form.macro-budget-warning.description")}
        routeToSamePage={true}
        removeButtons={true}
        onActionConfirmed={() => {
          setShowModalMacro(false);
        }}
        onCallBackClosed={() => {
          setShowModalMacro(false);
        }}
      />
    </>
  );
};

export default MacroCategoriesFormCst;
